import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { Image, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  display: flex;
  flex-direction: column;
  .SpecialCard_media {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,.25);
    position: relative;
  }
  .SpecialCard_image {
    width: 100%;
    position: relative;
    z-index: 1;
  }
  .SpecialCard_content {
    display: flex;
    height: 100%;
    justify-content: center;
    flex-direction: column;
    padding: 30px;
    background-color: rgba(0,0,0,.25);
    @media(min-width: 992px) {
      padding: 45px 60px;
    }
  }
  .SpecialCard_title {
    font-weight: 700;
    font-size: 24px;
    line-height: 1.1;
    text-transform: uppercase;
    font-family: ${typography.Condensed};
    text-align: left;
    color: ${colors.white};
    margin: 0 0 20px 0;
    position: relative;
    @media (min-width: 992px) {
      font-size: 32px;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 60px;
      height: 6px;
      left: 0;
      bottom: -22px;
      background-color: ${colors.brand1};
    }
  }
  .SpecialCard_description {
    p {
      font-size: 18px;
      color: ${colors.white};
      margin: 0 0 30px 0;
    }
  }
`;

function SpecialCard({ special }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 px-lg-0">
            <div className="SpecialCard_media">
              <Link
                name="special-offers-detail"
                params={{ title: get(special, 'headline') }}
                class="w-100 h-100"
              >
                <Image
                  src={get(special, 'image.contentUrl')}
                  alt={get(special, 'image.name', get(special, 'image.caption', ''))}
                  className="SpecialCard_image"
                  preserve
                />
              </Link>
            </div>
          </div>
          <div className="col-lg-6 px-lg-0">
            <div className="SpecialCard_content">
              <div>
                <h4 className="SpecialCard_title">{get(special, 'headline')}</h4>
                <div dangerouslySetInnerHTML={SanitizeHtml(get(special, 'short_description'))} className="SpecialCard_description" />
                <Link
                  name="special-offers-detail"
                  params={{ title: get(special, 'headline') }}
                  className="btn btn-brand3"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SpecialCard.propTypes = {
  special: PropTypes.object.isRequired,
};

export default SpecialCard;



// WEBPACK FOOTER //
// ./src/components/SpecialCardSingle.js